// extracted by mini-css-extract-plugin
export var content = "MediaCard-module--content--05a84";
export var cta = "MediaCard-module--cta--bb00d";
export var image = "MediaCard-module--image--cca85";
export var label = "MediaCard-module--label--8806a";
export var link_overlay = "MediaCard-module--link_overlay--d1d52";
export var title = "MediaCard-module--title--cb822";
export var wrapper = "MediaCard-module--wrapper--fb6cd";